import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import TextInput from '../../../../../shared/components/TextInput';
import axiosInstance from '../../../../../shared/utils/axios';
import history from '../../../../../history';
import {Button} from '../../../../../shared';
import debug from 'debug';
import {_openModal} from '../../../../../shared/reducers/modals';
import {openNewTab} from '../../../../utils/partners';
import Row from '../../../../../shared/components/Row';
import Page from '../../../../../shared/components/Page';
import Tile from '../../../../../shared/components/Tile';
import DescriptiveText from '../../../../../shared/components/DescriptiveText';

const log = debug('circleblack:redtail:login');

const RedtailLogin = (props) => {
  log('rendering');
  const {session, openModal} = props;
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [disabled, setDisabled] = useState(true);

  const updateUserName = (name, value) => setUserName(value);
  const updatePassword = (name, value) => setPassword(value);
  const login = () => {
    axiosInstance.put('/auth/redtail', {username: userName, password: password})
      .then(function resolve() {
        session.profile.redtail = true;
        history.push('/engage/redtail');
      }).catch(() => openModal({type: 'MessageModal', title: 'Authentication failed', body: 'Invalid username or password'}));
  };

  useEffect(() => {
    if (userName && password) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [userName, password]);

  return <Page>
    <Tile key='Redtail' title='Redtail'>
      <DescriptiveText>
        You can use Redtail through CircleBlack to see more features and update information between the two.
      </DescriptiveText>
      <DescriptiveText>
        Since this is your first time, please login using your Redtail credentials
      </DescriptiveText>
      <Row wrap={false}>
        <TextInput type={'Text'}
                   placeholder={'Username...'}
                   dataPoint={{name: 'userName', value: userName}}
                   required={true} onChange={updateUserName}/>
        <TextInput type={'password'}
                   placeholder={'Password...'}
                   dataPoint={{name: 'password', value: password}}
                   onChange={updatePassword}/>
      </Row>
      <Row wrap={false}>
        <Button importance={'primary'}
                size={'md'}
                label={'Login'}
                disabled={disabled}
                action={login}/>
        <Button importance={'primary'}
                size={'md'}
                label={'Register'}
                disabled={false}
                action={() => openNewTab('https://smf.accounts.redtailtechnology.com/freetrial')}/>
      </Row>
    </Tile>
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});
export default connect(mapStateToProps, mapDispatchToProps)(RedtailLogin);

RedtailLogin.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
  /**
   * The open function that dispatches _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
};

